module.exports = __webpack_public_path__ + "img/sdg7.8db6e283.svg";